// extracted by mini-css-extract-plugin
export default {"googleSignInBox":"SignInWithGoogle_googleSignInBox__K36LN","googleSignInText":"SignInWithGoogle_googleSignInText__3ovCa"};